import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@scoir/avatar';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["scid", "size"];
var FULL_SIZE = 'full';
var THUMB_SIZE = 'thumb';
var DEFAULT_COLLEGE_LOGO = "https://s3.amazonaws.com/scoir_static/assets/colleges/images";
var getCollegeImagePrefix = function getCollegeImagePrefix() {
  return window.COLLEGE_IMAGE_ENDPOINT || DEFAULT_COLLEGE_LOGO;
};
var imgSrc = function imgSrc(scid, size) {
  return getCollegeImagePrefix() + "/" + size + "-" + scid + "-0.png";
};
var fallbackImgSrc = function fallbackImgSrc(size) {
  return getCollegeImagePrefix() + "/college-crest-" + size + ".png";
};
var useStyles = makeStyles(function (theme) {
  return {
    fallbackIcon: {
      backgroundColor: get(theme, 'palette.pageBackground.main'),
      color: get(theme, 'palette.info.dark')
    },
    svg: {
      width: '40%'
    }
  };
});

var FallbackIcon = function FallbackIcon() {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "100%",
    position: "absolute",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    className: classes.fallbackIcon
  }, /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "university",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    className: classes.svg,
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
  })));
};

var CollegeCrest = function CollegeCrest(_ref) {
  var scid = _ref.scid,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var IMG_SIZE = size === 'xl' ? FULL_SIZE : THUMB_SIZE;
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    variant: "rounded",
    size: size,
    fallbackIcon: /*#__PURE__*/React.createElement(FallbackIcon, null),
    sourceUrl: imgSrc(scid, IMG_SIZE)
  }, rest));
};

CollegeCrest.propTypes = {
  scid: PropTypes.number,
  size: PropTypes.string
};

export { DEFAULT_COLLEGE_LOGO, FULL_SIZE, THUMB_SIZE, CollegeCrest as default, fallbackImgSrc, getCollegeImagePrefix, imgSrc };
//# sourceMappingURL=index.module.js.map
